if (!customElements.get('scrolling-gallery-carousel')) {
  customElements.define(
    'scrolling-gallery-carousel',
    class ScrollingGalleryCarousel extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = false;
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest('.scrolling-gallery-image');
        this.sliderWrapper = this.querySelector('.gallery-list');

        if (!this.section || !this.sliderWrapper) return;

        this.initSlider();
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const sliderOptions = {
          slidesPerView: 'auto',
          spaceBetween: 12,
          navigation: {
            nextEl: this.section.querySelector('.scrolling-gallery-image__button--next'),
            prevEl: this.section.querySelector('.scrolling-gallery-image__button--prev'),
          },
          loop: true,
          loopAdditionalSlides: 2,
          threshold: 2,
          watchSlidesProgress: true,
          breakpoints: {
            768: {
              spaceBetween: 20,
            },
          },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            if (slide) {
              this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            }
          });
        });

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            if (event.detail.sectionId !== this.sectionId) return;
            const index = Number(event.target.dataset.index);
            if (!Number.isNaN(index)) this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
